// extracted by mini-css-extract-plugin
export var deliveryRow = "_jq-a";
export var fixedHeight = "_jq-4";
export var freightLogo = "_jq-9";
export var fullWidth = "_jq-3";
export var priceColumn = "_jq-5";
export var radioSelected = "_jq-7";
export var radioUnselected = "_jq-6";
export var selectedOption = "_jq-2";
export var selectedOptionContainer = "_jq-1";
export var selection = "_jq-0";
export var tallSkeletonText = "_jq-8";